import React from 'react';
import { Grid, TextField, Typography, FormControl, InputLabel, Select, MenuItem, FormHelperText } from '@mui/material';
import { FormikProps } from 'formik';
import { FormValues } from '../EditClientDialog';

interface Props {
  formik: FormikProps<FormValues>;
  calculateAge: (year: string, month: string, day: string) => number;
}

const SoleTraderDetailsSection: React.FC<Props> = ({ formik, calculateAge }) => (
  <>
    <Grid item xs={12}>
      <Typography variant="subtitle1" gutterBottom>Date of Birth</Typography>
    </Grid>
    
    <Grid item xs={4}>
      <TextField
        fullWidth
        id="dobDay"
        name="dobDay"
        label="Day"
        type="number"
        InputProps={{ inputProps: { min: 1, max: 31 } }}
        value={formik.values.dobDay || ''}
        onChange={formik.handleChange}
        onBlur={formik.handleBlur}
        error={formik.touched.dobDay && Boolean(formik.errors.dobDay)}
        helperText={formik.touched.dobDay && formik.errors.dobDay}
      />
    </Grid>
    
    <Grid item xs={4}>
      <FormControl fullWidth>
        <InputLabel id="dob-month-label">Month</InputLabel>
        <Select
          labelId="dob-month-label"
          id="dobMonth"
          name="dobMonth"
          value={formik.values.dobMonth || ''}
          onChange={formik.handleChange}
          onBlur={formik.handleBlur}
          error={formik.touched.dobMonth && Boolean(formik.errors.dobMonth)}
          label="Month"
        >
          <MenuItem value="01">January</MenuItem>
          <MenuItem value="02">February</MenuItem>
          <MenuItem value="03">March</MenuItem>
          <MenuItem value="04">April</MenuItem>
          <MenuItem value="05">May</MenuItem>
          <MenuItem value="06">June</MenuItem>
          <MenuItem value="07">July</MenuItem>
          <MenuItem value="08">August</MenuItem>
          <MenuItem value="09">September</MenuItem>
          <MenuItem value="10">October</MenuItem>
          <MenuItem value="11">November</MenuItem>
          <MenuItem value="12">December</MenuItem>
        </Select>
        {formik.touched.dobMonth && formik.errors.dobMonth && (
          <FormHelperText error>{formik.errors.dobMonth}</FormHelperText>
        )}
      </FormControl>
    </Grid>
    
    <Grid item xs={4}>
      <FormControl fullWidth>
        <InputLabel id="dob-year-label">Year</InputLabel>
        <Select
          labelId="dob-year-label"
          id="dobYear"
          name="dobYear"
          value={formik.values.dobYear || ''}
          onChange={formik.handleChange}
          onBlur={formik.handleBlur}
          error={formik.touched.dobYear && Boolean(formik.errors.dobYear)}
          label="Year"
        >
          {Array.from({ length: 100 }, (_, i) => {
            const year = new Date().getFullYear() - i;
            return (
              <MenuItem key={year} value={year.toString()}>
                {year}
              </MenuItem>
            );
          })}
        </Select>
        {formik.touched.dobYear && formik.errors.dobYear && (
          <FormHelperText error>{formik.errors.dobYear}</FormHelperText>
        )}
      </FormControl>
    </Grid>
    
    {formik.values.dobDay && formik.values.dobMonth && formik.values.dobYear && (
      <Grid item xs={12}>
        <Typography variant="body2" color="textSecondary">
          Age: {calculateAge(formik.values.dobYear, formik.values.dobMonth, formik.values.dobDay)}
        </Typography>
      </Grid>
    )}
  </>
);

export default SoleTraderDetailsSection;
